export const buildNumber = '20260731.2';
export const version = 'main';
export const latestCommit = 'c00de2c664c2b8f7b301884e7551104875b5e089';
